<div class="container-fluid">
  <div class="mega_body-content">
    <ng-container *ngIf="showBanner">
      <div class="col-12 col-sm-12 col-md-12 col-lg-12">
        <div class="message-container">
          <!--<div class="row">-->
          <div class="col-1 col-sm-1 col-md-1 col-lg-1">
            <span class="status-icon fa-stack fa-lg">
              <i class="fa fa-info fa-stack-1x"></i>
              <i class="fa fa-circle-thin fa-stack-2x"></i>
            </span>
          </div>
          <div class="col-12 col-sm-12 col-md-10 col-lg-10">
            <div class="status-message">
              {{ messageBody }}
            </div>
          </div>
          <div class="col-1 col-sm-1 col-md-1 col-lg-1">
            <div class="exit-button float-end" (click)="closeMessageBanner()">
              <img src="assets/images/x_white.svg" />
            </div>
          </div>
        </div>
        <!--</div>-->
      </div>
    </ng-container>

    <div class="col-12 col-sm-12 col-md-12 col-lg-12">
      <ng-container *ngIf="showCommitError">
        <div class="row error-banner-container">
          <div class="col-1 col-sm-1 col-md-1 col-lg-1">
            <div class="status-icon">
              <img alt="" src="assets/images/icon_error_white.svg" />
            </div>
          </div>
          <div class="col-12 col-sm-12 col-md-9 col-lg-9">
            <p class="file-format-text">{{ commitErrorMessage }}</p>
          </div>
          <div class="col-1 col-sm-1 col-md-2 col-lg-2">
            <div class="exit-button float-end" (click)="closeCommitErrorBanner()">
              <img src="assets/images/x_white.svg" />
            </div>
          </div>
        </div>
      </ng-container>
    </div>

    <div class="col-12 col-sm-12 col-md-12 col-lg-12 mega_header-information">
      <div class="row">
        <div class="col-12 col-sm-12 col-md-12 col-lg-12">
          <div class="mega_header-information__sub-header">Review Pool Details</div>
        </div>
      </div>
    </div>

    <div class="col-12 col-sm-12 col-md-12 col-lg-12 line-break-container">
      <div class="line-break"></div>
    </div>

    <div class="col-12 col-sm-12 col-md-12 col-lg-12 pl-0">
      <div class="col-12 col-sm-12 col-md-3 col-lg-3">
        <div>Pool Type</div>
      </div>
    </div>
    <div class="row col-12 col-sm-12 col-md-12 col-lg-12 pl-0">
      <div class="col-12 col-sm-12 col-md-3 col-lg-3">
        <div class="fw-bold-and-size">
          <ng-container *ngIf="multiMegaCalculateFeeResponse.megaType === 'SFFIXMEGA'">
            Single Family Fixed Rate
          </ng-container>
          <ng-container *ngIf="multiMegaCalculateFeeResponse.megaType === 'SFARMMEGA'">
            Single Family ARM
          </ng-container>
          <ng-container *ngIf="multiMegaCalculateFeeResponse.megaType === 'MFFIXMEGA'">
            Multi Family Fixed Rate
          </ng-container>
          <ng-container *ngIf="multiMegaCalculateFeeResponse.megaType === 'MFARMMEGA'">
            Multi Family ARM
          </ng-container>
        </div>
      </div>
      <div class="col-12 col-sm-12 col-md-9 col-lg-9 visible-md-9 pr-0 d-flex justify-content-end">
        <span class="back-and-edit" (click)="goBack()">
          <i class="fa fa-arrow-circle-o-left go-back-icon"></i>Go back and edit
        </span>
        <span class="fw-bold-and-size total-mega-count"
          >Total Pools: {{ validatedMegaList.length }}</span
        >
      </div>
      <!-- <div class="visible-xs-12 hidden-md hidden-lg col-12">
        <span class="back-and-edit go-back-edit-link" (click)="goBack()">
              <i class="fa fa-arrow-circle-o-left go-back-icon"></i>Go back and edit
        </span>
        <span class="fw-bold-and-size col-12 pl-0">Total Pools: {{ validatedMegaList.length }}</span>
      </div> -->
    </div>

    <div class="row">
      <div class="col-12 pd-20">
        <div class="fm-cdx-table">
          <table class="fm-cdx-table__static">
            <thead>
              <tr class="th_row">
                <th class="th_column">POOL #</th>
                <th class="th_column width-25">CUSIP</th>
                <th class="th_column width-25">PREFIX</th>
                <ng-container *ngIf="multiMegaCalculateFeeResponse.megaType === 'SFFIXMEGA'">
                  <th class="th_column th_column--is-numeric">COUPON</th>
                </ng-container>
                <ng-container *ngIf="multiMegaCalculateFeeResponse.megaType === 'MFFIXMEGA'">
                  <th class="th_column th_column--is-numeric">HIGH COUPON</th>
                </ng-container>
                <ng-container *ngIf="multiMegaCalculateFeeResponse.megaType === 'MFFIXMEGA'">
                  <th class="th_column th_column--is-numeric">LOW COUPON</th>
                </ng-container>
                <ng-container
                  *ngIf="
                    multiMegaCalculateFeeResponse.megaType === 'SFARMMEGA' ||
                    multiMegaCalculateFeeResponse.megaType === 'MFARMMEGA'
                  "
                >
                  <th class="th_column">SUBTYPE</th>
                </ng-container>
                <th class="th_column th_column--is-numeric">DEAL AMOUNT</th>
                <th class="th_column pl-85">SETTLEMENT</th>
                <th class="th_column th_column--is-numeric">FEE</th>
              </tr>
            </thead>
            <tbody>
              <tr
                class="td_row commit-mega-table-header"
                *ngFor="let validatedMega of validatedMegaList; trackBy: trackByIdentity"
              >
                <td class="td_cell">
                  <span id="megaNumber" class="commit-to-recive-color">{{
                    validatedMega?.poolNumber ? validatedMega?.poolNumber : ''
                  }}</span>
                </td>
                <td class="td_cell">
                  <span id="cusip" class="commit-to-recive-color">{{
                    validatedMega?.cusip ? validatedMega?.cusip : ''
                  }}</span>
                </td>
                <td class="td_cell">
                  <span id="prefix">{{ validatedMega?.prefix ? validatedMega?.prefix : '' }}</span>
                </td>
                <ng-container *ngIf="multiMegaCalculateFeeResponse.megaType === 'SFFIXMEGA'">
                  <td class="td_cell td_cell--is-numeric">
                    <span id="sfFixedCoupon">{{
                      validatedMega?.sfFixedCoupon | number: '1.3-3'
                    }}</span>
                  </td>
                </ng-container>
                <ng-container *ngIf="multiMegaCalculateFeeResponse.megaType === 'MFFIXMEGA'">
                  <td class="td_cell td_cell--is-numeric">
                    <span id="mfHighCoupon">{{
                      validatedMega?.mfHighCoupon | number: '1.3-3'
                    }}</span>
                  </td>
                </ng-container>
                <ng-container *ngIf="multiMegaCalculateFeeResponse.megaType === 'MFFIXMEGA'">
                  <td class="td_cell td_cell--is-numeric">
                    <span id="mfLowCoupon">{{ validatedMega?.mfLowCoupon | number: '1.3-3' }}</span>
                  </td>
                </ng-container>
                <ng-container
                  *ngIf="
                    multiMegaCalculateFeeResponse.megaType === 'SFARMMEGA' ||
                    multiMegaCalculateFeeResponse.megaType === 'MFARMMEGA'
                  "
                >
                  <td class="td_cell">
                    <span id="sfARMSubType">{{ validatedMega?.sfARMSubType }}</span>
                  </td>
                </ng-container>
                <td class="td_cell td_cell--is-numeric">
                  <span id="tradeAmount">{{
                    validatedMega?.tradeAmount | currency: 'USD' : 'symbol' : '1.0'
                  }}</span>
                </td>
                <ng-container *ngIf="!validatedMega.earlyCloseFlag">
                  <td class="td_cell">
                    <span id="tradeSettlementDate">{{
                      validatedMega?.tradeSettlementDate | date: 'MM/dd/yyyy'
                    }}</span>
                  </td>
                </ng-container>
                <ng-container *ngIf="validatedMega.earlyCloseFlag">
                  <td class="td_cell">
                    <span id="tradeSettlementDate-earlyClose"
                      >{{ validatedMega?.tradeSettlementDate | date: 'MM/dd/yyyy'
                      }}<i class="fa fa-asterisk legend-icon pl-3"></i
                    ></span>
                  </td>
                </ng-container>
                <ng-container *ngIf="validatedMega?.newFeeDollars !== null">
                  <td class="td_cell td_cell--is-numeric">
                    <ng-container *ngIf="needsDisclaimer(validatedMega?.prefix); else noDisclaimer">
                      <span id="newFeeDollars" class="fw-bold fee-warning-red"
                        >{{ validatedMega?.newFeeDollars | currency: 'USD' : 'symbol' : '1.2-2' }}*
                      </span>
                    </ng-container>
                    <ng-template #noDisclaimer>
                      <span id="newFeeDollars" class="fw-bold"
                        >{{ validatedMega?.newFeeDollars | currency: 'USD' : 'symbol' : '1.2-2' }}
                      </span>
                    </ng-template>
                  </td>
                </ng-container>
                <ng-container *ngIf="validatedMega?.newFeeTicks !== null">
                  <td class="td_cell td_cell--is-numeric">
                    <ng-container *ngIf="needsDisclaimer(validatedMega?.prefix); else noDisclaimer">
                      <span id="newFeeTicks" class="fw-bold fee-warning-red"
                        >{{ validatedMega?.newFeeTicks | number: '1.3-3' }}/32*
                      </span>
                    </ng-container>
                    <ng-template #noDisclaimer>
                      <span id="newFeeTicks" class="fw-bold"
                        >{{ validatedMega?.newFeeTicks | number: '1.3-3' }}/32
                      </span>
                    </ng-template>
                  </td>
                </ng-container>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-12">
        <p class="fee-warning-red">
          {{ disclaimerMessage }}
        </p>
      </div>
    </div>
    <div class="row" *ngIf="showEarlyCloseLegend">
      <div class="col-12">
        <p>
          <i class="fa fa-asterisk legend-icon"></i>Market closes early on this day. Please be sure
          someone from the Structured Transactions team is available to complete this transaction.
        </p>
      </div>
    </div>
    <!--Mega pricing updates section-->
    <section class="mega-pricing-updates-section pd-20" *ngIf="megaPricingUpdateList !== null">
      <div class="row">
        <div class="col-12">
          <span>
            <i class="fa fa-exclamation-triangle warning-exclamation-icon"></i>
            <label class="fw-bold-and-size"> Pricing Updates -</label>
            <span class="mega-pricing-month fw-bold-and-size">
              {{ multiMegaCalculateFeeResponse?.pricingMonth | date: 'MMM' }}.
              {{ multiMegaCalculateFeeResponse?.pricingMonth | date: 'yyyy' }}</span
            >
          </span>
        </div>
      </div>
      <div class="row">
        <div class="col-12">
          <p class="font-size-13 mb-0">
            By looking the above pools, the pricing for the following booked pools will be affected.
          </p>
        </div>
      </div>
      <div class="row">
        <div class="col-12">
          <p class="font-size-13">
            Pricing changes will not go into effect until the new pools have been committed.
          </p>
        </div>
      </div>
      <div class="row">
        <div class="col-12 visible-md-12 d-flex justify-content-end">
          <div class="fw-bold-and-size">Total Pools: {{ megaPricingUpdateList.length }}</div>
        </div>
      </div>
      <!-- <div class="visible-xs-12 hidden-md hidden-lg col-12 pl-0 ">
        <span class="fw-bold-and-size total-mega-count col-12 pl-0">Total Pools: {{ megaPricingUpdateList.length}}</span>
      </div> -->
      <div class="row" *ngIf="megaPricingUpdateList !== null">
        <div class="col-12 mega-pricing-update-table px-0">
          <div class="fm-cdx-table">
            <table class="fm-cdx-table__static">
              <thead>
                <tr class="th_row">
                  <th class="th_column">POOL #</th>
                  <th class="th_column width-25">CUSIP</th>
                  <th class="th_column th_column--is-numeric">DEAL AMOUNT</th>
                  <th class="th_column pl-85">SETTLEMENT</th>
                  <th class="th_column th_column--is-numeric">PREVIOUS FEE</th>
                  <th class="th_column th_column--is-numeric">NEW FEE</th>
                </tr>
              </thead>
              <tbody>
                <tr
                  class="td_row commit-mega-pricing-update-table-header"
                  *ngFor="let megaPricing of megaPricingUpdateList; trackBy: trackByIdentity"
                >
                  <td class="td_cell">
                    <span class="pool-item-mega-number">{{ megaPricing?.poolNumber }}</span>
                  </td>
                  <td class="td_cell">
                    <span class="pool-item-cusip">{{ megaPricing?.cusip }}</span>
                  </td>
                  <td class="td_cell td_cell--is-numeric">
                    <span class="pool-item-trade-amount">{{
                      megaPricing?.tradeAmount | currency: 'USD' : 'symbol' : '1.0'
                    }}</span>
                  </td>
                  <ng-container *ngIf="!megaPricing.earlyCloseFlag">
                    <td class="td_cell pl-85">
                      <span id="pool-item-settlement-date">{{
                        megaPricing?.tradeSettlementDate | date: 'MM/dd/yyyy'
                      }}</span>
                    </td>
                  </ng-container>
                  <ng-container *ngIf="megaPricing.earlyCloseFlag">
                    <td class="td_cell pl-85">
                      <span id="pool-item-settlement-date-earlyClose"
                        >{{ megaPricing?.tradeSettlementDate | date: 'MM/dd/yyyy'
                        }}<i class="fa fa-asterisk legend-icon pl-3"></i
                      ></span>
                    </td>
                  </ng-container>
                  <td class="td_cell td_cell--is-numeric">
                    <ng-container *ngIf="megaPricing?.prevFeeDollars !== null">
                      <span class="pool-item-trade-amount fw-bold">{{
                        megaPricing?.prevFeeDollars | currency: 'USD' : 'symbol' : '1.2-2'
                      }}</span>
                    </ng-container>
                    <ng-container *ngIf="megaPricing?.prevFeeTicks !== null">
                      <span class="pool-item-trade-amount fw-bold"
                        >{{ megaPricing?.prevFeeTicks | number: '1.3-3' }}/32</span
                      >
                    </ng-container>
                  </td>
                  <td class="td_cell td_cell--is-numeric">
                    <ng-container *ngIf="megaPricing?.newFeeDollars !== null">
                      <ng-container
                        *ngIf="needsDisclaimer(megaPricing?.prefix); else noDisclaimerUpdateList"
                      >
                        <span class="pool-item-trade-amount fw-bold fee-warning-red"
                          >{{
                            megaPricing?.newFeeDollars | currency: 'USD' : 'symbol' : '1.2-2'
                          }}*</span
                        >
                      </ng-container>
                      <ng-template #noDisclaimerUpdateList>
                        <span class="pool-item-trade-amount fw-bold">{{
                          megaPricing?.newFeeDollars | currency: 'USD' : 'symbol' : '1.2-2'
                        }}</span>
                      </ng-template>
                    </ng-container>
                    <ng-container *ngIf="megaPricing?.newFeeTicks !== null">
                      <ng-container
                        *ngIf="
                          needsDisclaimer(megaPricing?.prefix);
                          else noTickDisclaimerUpdateList
                        "
                      >
                        <span class="pool-item-trade-amount fw-bold fee-warning-red"
                          >{{ megaPricing?.newFeeTicks | number: '1.3-3' }}/32*
                        </span>
                      </ng-container>
                      <ng-template #noTickDisclaimerUpdateList>
                        <span class="pool-item-trade-amount fw-bold"
                          >{{ megaPricing?.newFeeTicks | number: '1.3-3' }}/32
                        </span>
                      </ng-template>
                    </ng-container>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <div class="row">
            <div class="col-12 pd-20">
              <p class="fee-warning-red">
                {{ disclaimerMessage }}
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
    <div class="row" *ngIf="showEarlyCloseLegendPricingSummary">
      <div class="col-12 pd-20">
        <p>
          <i class="fa fa-asterisk legend-icon"></i>Market closes early on this day. Please be sure
          someone from the Structured Transactions team is available to complete this transaction.
        </p>
      </div>
    </div>
    <div class="row">
      <div class="col-12 pd-20">
        <div class="row">
          <div class="col-12">
            <label class="terms-conditions-title">Terms & Conditions</label>
          </div>
        </div>
        <div class="row">
          <div class="col-8">
            <p>
              By entering into a Supers transaction where the settlement is scheduled less than 48
              hours after the transaction has been booked, an investor is thereby agreeing to waive
              application of the 48-Hour Rule, as provided in Section B-2 of Chapter 7 of the
              Uniform Practices Manual, as published by the Securities Industry and Financial
              Markets Association.
            </p>
            <p>
              The use of this application is subject to the terms of your existing contractual
              arrangements with Fannie Mae including, without limitation, the Software Subscription
              Agreement or Technology License Agreement and any applicable contracts relating to the
              acquisition and distribution of Megas securities or Supers securities (collectively,
              the “Securities Contracts”). By clicking the “Commit” button below, you are entering
              into a legally-binding commitment under the applicable Securities Contracts to acquire
              Megas securities or Supers securities from Fannie Mae, as applicable, pursuant to the
              terms and conditions set forth in this application and any application-related
              confirmations.
            </p>
          </div>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-12">
        <div class="commit-cancel">
          <button
            class="button fm-primary-button"
            (click)="commitMultipleMegas()"
            [disabled]="isCommitButtonClicked"
          >
            Commit
          </button>
          <button class="button fm-tertiary-button" (click)="showCancelPopup = true">Cancel</button>
        </div>
      </div>
      <div class="enter-mega-model-window" *ngIf="showCancelPopup">
        <div class="panel panel-default fadeInUpBig">
          <button
            type="button"
            class="close float-end"
            aria-label="Close"
            (click)="showCancelPopup = false"
          >
            <span aria-hidden="true">&times;</span>
          </button>
          <div class="panel-body mega-cancel-confirmation-model">
            <ng-container>
              <h4>Are you sure you want to leave this page?</h4>
              <br />
              <p>
                You are about to leave the page before you have committed these pools. All
                information you have entered will be lost and you would be starting all over again.
              </p>
              <br />
            </ng-container>
            <button class="button fm-tertiary-button" (click)="showCancelPopup = false">NO</button>
            <button class="button fm-primary-button" (click)="cancelMultiMegaCommit()">YES</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
